module.exports = __webpack_public_path__ + "static/media/sap.d6d297fa.svg";